"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieChart = void 0;
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
var styles_1 = require("../../styles");
var model_1 = require("./model");
function PieChart(props) {
    var data = props.data, width = props.width, height = props.height, colorScheme = props.colorScheme;
    var theme = styles_1.useTheme();
    var cs = model_1.getChartColorScheme(colorScheme !== null && colorScheme !== void 0 ? colorScheme : 'default');
    return (react_1.default.createElement(recharts_1.PieChart, { width: width, height: height, style: {
            fontFamily: theme.typography.fontFamily,
            fontSize: '0.8rem',
            color: theme.pallete.gray.c20,
        } },
        react_1.default.createElement(recharts_1.Pie, { nameKey: 'name', dataKey: 'value', paddingAngle: 0, startAngle: 90, endAngle: 450, data: data, label: function (props) { return renderCustomizedLabel(props, theme); }, legendType: 'circle', isAnimationActive: false }, data.map(function (entry, index) {
            var _a, _b;
            return (react_1.default.createElement(recharts_1.Cell, { key: "cell-" + index, stroke: (_a = entry.color) !== null && _a !== void 0 ? _a : cs[index % cs.length], fill: (_b = entry.color) !== null && _b !== void 0 ? _b : cs[index % cs.length] }));
        }))));
}
exports.PieChart = PieChart;
function renderCustomizedLabel(props, theme) {
    var x = props.x, y = props.y, textAnchor = props.textAnchor, name = props.name, value = props.value;
    var dx = textAnchor === 'start' ? 10 : -10;
    return (react_1.default.createElement("text", { x: x, y: y, dx: dx, textAnchor: textAnchor, alignmentBaseline: 'middle', fill: theme.pallete.gray.c20 },
        react_1.default.createElement("tspan", { style: { fontWeight: 'bold' } }, value),
        react_1.default.createElement("tspan", { x: x, dx: dx, dy: 18 }, name)));
}
//# sourceMappingURL=PieChart.js.map